<template>

    <div class="searchbar flex flex-grow overflow-hidden text-sm
         w-full absolute top-4 rounded-md " v-bind:class="{
            'bg-birdie-blue/10': current_search,
        }">

        <div class=" flex flex-grow" id="searchresults">


            <!-- v-show="input_focused || whereIsMouse == 'list'" -->
            <ul class="flex flex-grow flex-col justify-start">

                <li class="flex flex-grow items-center relative">

                    <div id="searchIcon" class="flex self-center mx-2 text-gray-500">
                        <MagnifyingGlassIcon v-if="!searching" :class="[open ? 'opacity-0' : 'opacity-100']"
                            class="h-4 w-4 align-middle mr-1">
                        </MagnifyingGlassIcon>

                    </div>

                    <input :class="[current_search ? 'placeholder:text-gray-400' : 'placeholder:text-gray-300',
                        ' w-full border-0 focus:ring-0 flex flex-grow text-sm px-0.5 bg-transparent']" type="text"
                        id='input_in_box' tabindex="-1" @focus.prevent="$event.target.blur()" @mousedown.prevent
                        @click.prevent="focusInput" :placeholder="open || current_search
                            ? '' : 'Search for recordings…'" />

                    <div id="searchFor" v-if="current_search"
                        class="absolute top-0 left-8 h-full select-none text-base text-gray-500 sm:text-sm pr-2 flex items-center ">
                        Search results for: <span class="font-bold text-birdie-blue ml-1 truncate overflow-hidden">{{
                            $page.props.searched
                            }}</span>
                        <inertia-link :href="route('library.personal')" class="text-gray-400 hover:text-gray-500 ml-3">
                            <XCircleIcon class="size-4 mt-px" />
                        </inertia-link>
                    </div>
                </li>
            </ul>
        </div>









        <TransitionRoot :show="open" as="template" @after-leave="rawQuery = ''" appear>
            <Dialog class="relative" @close="closeInput" style="z-index: 10000">
                <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0"
                    enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
                    <div class="fixed inset-0 bg-gray-500/45 backdrop-blur-sm transition-opacity" />
                </TransitionChild>

                <div class="fixed inset-0 z-10 w-screen overflow-y-auto p-4 sm:p-6 md:p-20">
                    <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 scale-95"
                        enter-to="opacity-100 scale-100" leave="ease-in duration-200" leave-from="opacity-100 scale-100"
                        leave-to="opacity-0 scale-95">
                        <DialogPanel
                            class="mx-auto max-w-xl transform divide-y divide-gray-100 overflow-hidden rounded-xl bg-white shadow-2xl ring-1 ring-black/5 transition-all">
                            <Combobox @update:modelValue="onSelect">
                                <div class="grid grid-cols-1">
                                    <ComboboxInput
                                        class="col-start-1 row-start-1 h-12 w-full pl-11 pr-4  text-gray-900 outline-none border-0 focus:ring-0 flex flex-grow text-sm px-0.5 bg-transparent"
                                        placeholder="Search for recordings…" @change="rawQuery = $event.target.value"
                                        v-on:keyup="autoComplete" @blur="query = ''" />
                                    <MagnifyingGlassIcon v-if="!searching"
                                        class="pointer-events-none col-start-1 row-start-1 ml-4 size-5 self-center text-gray-400"
                                        aria-hidden="true" />
                                    <spinner v-else
                                        class="pointer-events-none col-start-1 row-start-1 ml-4 size-5 self-center text-gray-400">
                                    </spinner>
                                </div>

                                <ComboboxOptions
                                    v-if="filteredVideos.length > 0 || filteredUsers.length > 0 || filteredTags.length > 0 || filteredContacts.length > 0 || filteredTickets.length > 0 || filteredFolders.length > 0"
                                    static as="ul"
                                    class="max-h-80 transform-gpu scroll-py-10 scroll-pb-2 space-y-4 overflow-y-auto p-4 pb-2">
                                    <li v-if="filteredVideos.length > 0">
                                        <h2 class="text-xs font-semibold text-gray-900">Video Title</h2>
                                        <ul class="-mx-4 mt-2 text-sm text-gray-700">
                                            <ComboboxOption v-for="video in filteredVideos" :key="video.id"
                                                :value="video" as="template" v-slot="{ active }">
                                                <li
                                                    :class="['flex cursor-default select-none items-center px-4 py-2', active && 'bg-birdie-blue text-white outline-none']">
                                                    <PlayIcon
                                                        :class="['size-5 flex-none', active ? 'text-white forced-colors:text-[Highlight]' : 'text-gray-400']"
                                                        aria-hidden="true" />
                                                    <span class="ml-3 flex-auto truncate">{{ video.title }}</span>
                                                    <span class="flex-shrink-0">{{ video.created_at
                                                        }}</span>

                                                </li>
                                            </ComboboxOption>
                                        </ul>
                                    </li>
                                    <li v-if="filteredFolders.length > 0">
                                        <h2 class="text-xs font-semibold text-gray-900">Folder</h2>
                                        <ul class="-mx-4 mt-2 text-sm text-gray-700">
                                            <ComboboxOption v-for="folder in filteredFolders" :key="folder.id"
                                                :value="folder" as="template" v-slot="{ active }">
                                                <li
                                                    :class="['flex cursor-default select-none items-center px-4 py-2', active && 'bg-birdie-blue text-white outline-none']">
                                                    <FolderIcon
                                                        :class="['size-5 flex-none', active ? 'text-white forced-colors:text-[Highlight]' : 'text-gray-400']"
                                                        aria-hidden="true" />
                                                    <span class="ml-3 flex-shrink-0">{{
                                                        capitalizeFirst(folder.root) }} /</span>
                                                    <span v-if="folder.is_secure" class="ml-1 flex-shrink-0">
                                                        <LockClosedIcon class="size-3" />
                                                    </span>
                                                    <span class="ml-1 flex-grow truncate">{{
                                                        folder.name }}</span>
                                                </li>
                                            </ComboboxOption>
                                        </ul>
                                    </li>
                                    <li v-if="filteredTickets.length > 0">
                                        <h2 class="text-xs font-semibold text-gray-900">Received videos matching a
                                            ticket ID</h2>
                                        <ul class="-mx-4 mt-2 text-sm text-gray-700">
                                            <ComboboxOption v-for="ticketVideo in filteredTickets" :key="ticketVideo.id"
                                                :value="ticketVideo" as="template" v-slot="{ active }">
                                                <li
                                                    :class="['flex cursor-default select-none items-center px-4 py-2', active && 'bg-birdie-blue text-white outline-none']">
                                                    <!-- <div
                                                        class="w-5 h-5 rounded-full object-cover bg-gray-400 flex items-center justify-center">
                                                        <img :src="'/img/' + ticketVideo.publication_name + '_white.svg'"
                                                            class="w-3 h-3">
                                                    </div> -->
                                                    <PlayIcon
                                                        :class="['size-5 flex-none', active ? 'text-white forced-colors:text-[Highlight]' : 'text-gray-400']"
                                                        aria-hidden="true" />
                                                    <span class="ml-3 flex-auto truncate">Posted into <strong>{{
                                                        ticketVideo.publication_name.charAt(0).toUpperCase() +
                                                        ticketVideo.publication_name.slice(1) }}</strong> #{{
                                                                ticketVideo.object_id }}</span>
                                                    <span class="flex-shrink-0">{{ ticketVideo.publication_timestamp
                                                        }}</span>

                                                </li>
                                            </ComboboxOption>
                                        </ul>
                                    </li>
                                    <li v-if="filteredUsers.length > 0">
                                        <h2 class="text-xs font-semibold text-gray-900">Team Members</h2>
                                        <ul class="-mx-4 mt-2 text-sm text-gray-700">
                                            <ComboboxOption v-for="user in filteredUsers" :key="user.id" :value="user"
                                                as="template" v-slot="{ active }">
                                                <li
                                                    :class="['flex cursor-default select-none items-center px-4 py-2', active && 'bg-birdie-blue text-white outline-none']">
                                                    <ProfileImage :user="user" size="size-5" />


                                                    <!-- <UsersIcon
                                                        :class="['size-5 flex-none', active ? 'text-white forced-colors:text-[Highlight]' : 'text-gray-400']"
                                                        aria-hidden="true" /> -->
                                                    <span class="ml-3 flex-auto truncate"
                                                        v-html="user_pill(user)"></span>
                                                    <span class="flex-shrink-0" v-if="user.videos_count > 1">{{
                                                        user.videos_count }}
                                                        videos</span>
                                                    <span class="flex-shrink-0" v-else>1 video</span>
                                                </li>
                                            </ComboboxOption>
                                        </ul>
                                    </li>
                                    <li v-if="filteredTags.length > 0">
                                        <h2 class="text-xs font-semibold text-gray-900">Tags</h2>
                                        <ul class="-mx-4 mt-2 text-sm text-gray-700">
                                            <ComboboxOption v-for="tag in filteredTags" :key="tag.id" :value="tag"
                                                as="template" v-slot="{ active }">
                                                <li
                                                    :class="['flex cursor-default select-none items-center px-4 py-2', active && 'bg-birdie-blue text-white outline-none']">
                                                    <TagIcon
                                                        :class="['size-5 flex-none', active ? 'text-white forced-colors:text-[Highlight]' : 'text-gray-400']"
                                                        aria-hidden="true" />
                                                    <span class="ml-3 flex-auto truncate">{{ tag.name }}</span>
                                                    <span class="flex-shrink-0" v-if="tag.videos_count > 1">{{
                                                        tag.videos_count }}
                                                        videos</span>
                                                    <span class="flex-shrink-0" v-else>1 video</span>
                                                </li>
                                            </ComboboxOption>
                                        </ul>
                                    </li>
                                    <li v-if="filteredContacts.length > 0">
                                        <h2 class="text-xs font-semibold text-gray-900">Contacts</h2>
                                        <ul class="-mx-4 mt-2 text-sm text-gray-700">
                                            <ComboboxOption v-for="contact in filteredContacts" :key="contact.id"
                                                :value="contact" as="template" v-slot="{ active }">
                                                <li
                                                    :class="['flex cursor-default select-none items-center px-4 py-2', active && 'bg-birdie-blue text-white outline-none']">
                                                    <UserIcon
                                                        :class="['size-5 flex-none', active ? 'text-white forced-colors:text-[Highlight]' : 'text-gray-400']"
                                                        aria-hidden="true" />
                                                    <span class="ml-3 flex-auto truncate"
                                                        v-html="contact_pill(contact)"></span>
                                                    <span class="flex-shrink-0" v-if="contact.videos_count > 1">{{
                                                        contact.videos_count }}
                                                        videos</span>
                                                    <span class="flex-shrink-0" v-else>1 video</span>
                                                </li>
                                            </ComboboxOption>
                                        </ul>
                                    </li>
                                </ComboboxOptions>

                                <div v-if="rawQuery === '?'" class="px-6 pt-10 pb-14 text-center text-sm sm:px-14">
                                    <LifebuoyIcon class="mx-auto size-6 text-gray-400" aria-hidden="true" />
                                    <p class="mt-4 font-semibold text-gray-900">Help with searching</p>
                                    <p class="mt-2 text-gray-500">Search video titles, members, contacts, or
                                        tags.<br />Type at least 3 characters, and precede with # to search for a
                                        specific ticket ID.<br />Results are limited – keep typing for more accurate
                                        results.
                                    </p>
                                </div>

                                <div v-if="results_empty && rawQuery !== '?' && !searching"
                                    class="px-6 py-14 text-center text-sm sm:px-14">
                                    <ExclamationTriangleIcon class="mx-auto size-6 text-gray-400" aria-hidden="true" />
                                    <p class="mt-4 font-semibold text-gray-900">No results found</p>
                                    <p class="mt-2 text-gray-500">We couldn't find anything with that term. Please try
                                        again.</p>
                                </div>

                                <div class="flex flex-wrap items-center bg-gray-50 px-4 py-2.5 text-xs text-gray-700">
                                    Type
                                    <kbd
                                        :class="['mx-1 flex size-5 items-center justify-center rounded border bg-white font-semibold sm:mx-2', rawQuery.startsWith('#') ? 'border-birdie-blue text-birdie-blue' : 'border-gray-400 text-gray-900']">#</kbd>
                                    <span class="inline">for ticket IDs, and</span>
                                    <!-- <kbd
                                        :class="['mx-1 flex size-5 items-center justify-center rounded border bg-white font-semibold sm:mx-2', rawQuery.startsWith('>') ? 'border-birdie-blue text-birdie-blue' : 'border-gray-400 text-gray-900']">&#8617;</kbd>
                                    to search, and -->
                                    <kbd
                                        :class="['mx-1 flex size-5 items-center justify-center rounded border bg-white font-semibold sm:mx-2', rawQuery === '?' ? 'border-birdie-blue text-birdie-blue' : 'border-gray-400 text-gray-900']">?</kbd>
                                    for help.
                                </div>
                            </Combobox>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </Dialog>
        </TransitionRoot>

    </div>


</template>




<script>

import Spinner from '@/Components/UI/Spinner'
const CancelToken = axios.CancelToken;
let cancel;
import {
    MagnifyingGlassIcon, UserIcon, UsersIcon, PlayIcon,
    TagIcon, ExclamationTriangleIcon, LifebuoyIcon, FolderIcon
} from '@heroicons/vue/20/solid'
import { XCircleIcon, LockClosedIcon } from "@heroicons/vue/16/solid";
import ProfileImage from '@/Components/UI/ProfileImage'


import {
    Combobox,
    ComboboxInput,
    ComboboxOptions,
    ComboboxOption,
    Dialog,
    DialogPanel,
    TransitionChild,
    TransitionRoot,
} from '@headlessui/vue'



export default {

    props: ['searchroute', 'searchType', 'autofocus'],

    data() {
        return {
            is_router: false,
            // query: '',
            results_template: { videos: { data: [] }, folders: { data: [] }, tags: { data: [] }, contacts: { data: [] }, users: { data: [] }, live: { data: [] } },
            results: { videos: { data: [] }, folders: { data: [] }, tags: { data: [] }, contacts: { data: [] }, users: { data: [] }, live: { data: [] } },
            input_focused: false,
            list_focused: false,
            searching: false,
            whereIsMouse: '',
            lastTypeMoment: 0,
            timeout: Object,
            buffer: 100,
            results_empty: false,
            current_search: false,


            rawQuery: '',
            open: false,
        }
    },
    components: {
        Spinner, MagnifyingGlassIcon, XCircleIcon,
        Combobox,
        ComboboxInput,
        ComboboxOptions,
        ComboboxOption,
        Dialog,
        DialogPanel,
        TransitionChild,
        TransitionRoot,
        UserIcon, UsersIcon, TagIcon,
        PlayIcon, ExclamationTriangleIcon,
        LifebuoyIcon, FolderIcon, LockClosedIcon,
        ProfileImage
    },
    created: function () {
        this.updateCurrentSearch()
        const removeListener = this.$inertia.on('navigate', () => {
            this.updateCurrentSearch()
        })
        // Remove the event listener when component is unmounted
        this.$watch(() => this.$inertia, () => {
            removeListener()
        }, { immediate: false })
    },
    mounted: function () {
        if (this.autofocus) {
            if (this.autofocus === true) {
                this.focusInput()
            }
        }
    },
    computed: {
        query: function () {
            return this.rawQuery.toLowerCase()
            //return this.rawQuery.toLowerCase().replace(/^[#>]/, '')
        },
        show_results() {
            return this.input_focused || this.whereIsMouse == 'list'
        },
        filteredVideos() {
            return this.results.videos?.data.length > 0 ? this.results.videos.data : []
        },
        filteredUsers() {
            return this.results.users?.data.length > 0 ? this.results.users.data : []
        },
        filteredTags() {
            return this.results.tags?.data.length > 0 ? this.results.tags.data : []
        },
        filteredContacts() {
            return this.results.contacts?.data.length > 0 ? this.results.contacts.data : []
        },
        filteredTickets() {
            return this.results.tickets?.data.length > 0 ? this.results.tickets.data : []
        },
        filteredFolders() {
            return this.results.folders?.data.length > 0 ? this.results.folders.data : []
        },
    },
    methods:
    {

        capitalizeFirst(str) {
            return str.charAt(0).toUpperCase() + str.slice(1);
        },

        onSelect(item) {
            if (item) {
                this.$inertia.visit(item.url)
                this.closeInput()
            }
        },

        updateCurrentSearch() {
            this.current_search = route().current('library.search')
        },
        cancel() {
            cancel();
        },
        clicked() {
            clearTimeout(this.timeout);
            // setTimeout(function(){
            this.blurInput()
            this.results_empty = false;
            this.searching = false;
            this.results = this.results_template;
            // }.bind(this),100)
        },
        user_pill: function (user) {
            if (user.name) {
                if (user.name.toLowerCase().includes(this.query.toLowerCase())) {
                    return user.name;
                }
            }
            return user.email;
        },
        // live_pill: function (session) {
        //     if (session.contact_name) {
        //         if (session.contact_name.toLowerCase().includes(this.query.toLowerCase())) {
        //             return session.contact_name;
        //         }
        //     }
        //     if (session.contact_email) {
        //         if (session.contact_email.toLowerCase().includes(this.query.toLowerCase())) {
        //             return session.contact_email;
        //         }
        //     }
        //     if (session.contact_phone) {
        //         if (session.contact_phone.toLowerCase().includes(this.query.toLowerCase())) {
        //             return session.contact_phone;
        //         }
        //     }
        //     if (session.tab_title) {
        //         if (session.tab_title.toLowerCase().includes(this.query.toLowerCase())) {
        //             if (session.tab_title.length > 18) {
        //                 return session.tab_title.substr(0, 15) + '…'
        //             } else {
        //                 return session.tab_title
        //             }
        //         }
        //     }
        //     return session.ip;
        // },
        contact_pill: function (contact) {
            if (contact.email) {
                if (contact.email.toLowerCase().includes(this.query.toLowerCase())) {
                    return contact.email;
                }
            }
            if (contact.name) {
                if (contact.name.toLowerCase().includes(this.query.toLowerCase())) {
                    return contact.name;
                }
            }
            if (contact.identifier) {
                if (contact.identifier.toLowerCase().includes(this.query.toLowerCase())) {
                    return contact.identifier;
                }
            }
            if (contact.email) {
                return contact.email;
            }
            if (contact.name) {
                return contact.name;
            }
            if (contact.identifier) {
                return contact.identifier;
            }
            return '';
        },
        autoComplete: function (e) {
            if (e.keyCode === 13 || e.keyCode === 0) {
                return;
            }
            if (this.query.length > 2) {

                let now = new Date().getTime();

                if (now - this.lastTypeMoment < this.buffer) {
                    clearTimeout(this.timeout);
                }

                if (this.searching) {
                    this.cancel();
                }

                this.timeout = setTimeout(function () { this.makeSearch() }.bind(this), this.buffer);

                this.lastTypeMoment = now;

            } else {
                this.results_empty = false;
                this.searching = false;
                clearTimeout(this.timeout);
                this.results = this.results_template;
                // this.EventBus.emit("searchLive", "")
            }
        },
        makeSearch: function () {
            // if (this.searchType == "live") {
            //     //this.EventBus.emit("searchLive", this.query)
            //     return
            // }
            this.searching = true;
            this.results_empty = false;
            var url = this.$page.props.api_url + '/v1/search';
            // console.log("query", this.query)
            var params = {};
            axios.get(url, { params: { query: this.query } }, {
                cancelToken: new CancelToken(function executor(c) {
                    // An executor function receives a cancel function as a parameter
                    cancel = c;
                })
            })
                .then(response => {
                    this.results = response.data;

                    this.results_empty = response.data.videos.data.length == 0 && response.data.tags.data.length == 0 && response.data.contacts.data.length == 0 && response.data.users.data.length == 0 && response.data.tickets.data.length == 0 && response.data.folders.data.length == 0;
                    this.searching = false;
                    if (!this.results_empty) {


                        for (var i = 0; i < this.results.videos.data.length; i++) {
                            this.results.videos.data[i].url = route('library.video', { video_uuid: this.results.videos.data[i].uuid });
                            const date = new Date(this.results.videos.data[i].created_at);
                            this.results.videos.data[i].created_at = date.toLocaleDateString('en-US', {
                                year: 'numeric',
                                month: 'long',
                                day: 'numeric'
                            });
                        }
                        for (var i = 0; i < this.results.tags.data.length; i++) {
                            this.results.tags.data[i].url = this.searchroute + '?tag=' + encodeURIComponent(this.results.tags.data[i].slug)
                        }
                        for (var i = 0; i < this.results.contacts.data.length; i++) {
                            this.results.contacts.data[i].url = this.searchroute + '?contact=' + encodeURIComponent(this.results.contacts.data[i].email)
                        }
                        for (var i = 0; i < this.results.users.data.length; i++) {
                            this.results.users.data[i].url = this.searchroute + '?user=' + encodeURIComponent(this.results.users.data[i].email)
                        }
                        for (var i = 0; i < this.results.folders.data.length; i++) {
                            this.results.folders.data[i].url = route('library.' + this.results.folders.data[i].root, { folder_slug: this.results.folders.data[i].slug })
                        }
                        if (this.results.tickets?.data) {
                            for (var i = 0; i < this.results.tickets.data.length; i++) {
                                this.results.tickets.data[i].url = route('library.video', { video_uuid: this.results.tickets.data[i].uuid });
                                const date = new Date(this.results.tickets.data[i].publication_timestamp);
                                this.results.tickets.data[i].publication_timestamp = date.toLocaleDateString('en-US', {
                                    year: 'numeric',
                                    month: 'long',
                                    day: 'numeric'
                                });
                            }
                        }
                        // console.log("filteredTickets", this.filteredTickets)
                    }
                })
                .catch((thrown) => {
                    if (axios.isCancel(thrown)) {
                    } else {
                        console.log(thrown)
                    }
                    this.searching = false;
                });
            //.catch(e => console.log(e));
        },
        selection() {

            // WAITING TO SOLVE THE BUG
            //return;

            if (this.results_empty || this.query.length < 3) {
                return;
            }
            // if (this.searchType == "live") {
            //     return
            // }
            let encoded = encodeURIComponent(this.query); //btoa(this.query);

            // if (this.is_router == true) {
            //   this.$router.push({ path: '/users/search/'+encoded });
            // } else {

            // if (this.searchType == "live") {
            //     window.location.href = this.searchroute + '?search='+encoded;
            // } else {
            window.location.href = this.searchroute + '?q=' + encoded;
            // }
            // }
        },
        mouseoverInput() {
            this.whereIsMouse = '';
        },
        mouseleaveInput() {
            this.whereIsMouse = '';
        },
        mouseleaveList() {
            this.whereIsMouse = '';
        },
        mouseoverList() {
            this.whereIsMouse = 'list';
        },
        focusInput: function (event) {
            console.log('focusInput');
            this.input_focused = true;
            setTimeout(function () {
                document.getElementById('input_in_box').blur();
            }.bind(this), 100);
            this.open = true;
        },
        blurInput: function (event) {
            setTimeout(function () {
                this.input_focused = false;
            }.bind(this), 100);
        },
        closeInput: function (event) {
            this.input_focused = false;
            const inputElement = document.getElementById('input_in_box');
            inputElement?.blur();
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
            setTimeout(function () {
                this.open = false;
                this.rawQuery = '';
                this.results = []
                this.searching = false;
            }.bind(this), 100);

        },
        router_push_user: function (user_id) {
            this.whereIsMouse = '';
            this.results = [];
            if (this.$route.name == "user") {
                var parameters = this.$route.params;
                if (parameters.persona_id) {
                    parameters.persona_id = user_id;
                }
                this.$router.push({ name: 'user', params: parameters });
            } else {
                this.$router.push({ name: 'user', params: { persona_id: user_id } });
            }
        }
    }
}

</script>





<style scoped>
.fade-enter {
    opacity: 0;
}

.fade-enter-active {
    transition: all 0.2s ease-out;
}

.fade-leave-to {
    opacity: 0;
}

.fade-leave-active {
    transition: all 0.2s ease-in;
}

.searchbar_shadow,
.searchbar_shadow_live {
    filter: drop-shadow(rgba(0, 0, 0, 0.04) 0px 0px 15px) drop-shadow(rgba(0, 0, 0, 0.1) 0px 0px 9px);
    /* position: absolute; */
    /* fixed top-0 left-2p width-96p
        md:absolute md:top-auto md:left-auto md:w-full */

}


/* @media (max-width: 767px) {
    .searchbar_shadow {
        position: fixed;
        left: 2%;
        width: 96%;
    }
} */


/* #searchresults {
    position: absolute;
    left: 0;
    z-index: 99;
    right: 0;
    top: -12px;
  } */

/* .searchbar {
    position: relative;
  }

  .searchbar input.searchform {
    background: none;
    border-radius: 0;
    border: 0;
    padding-top: 0;
    padding-left: 23px;
  }

  .form-control.searchform:focus {
    background: #FFF;
    outline: none;
    outline-style: none;
    outline-offset: 0;
    outline-width: 0;
  }

  .nav-search-container #searchIcon {
      position: absolute;
      left: 14px;
      top: 3px;
      color: #888;
      background: none;
      padding-left: 0;

  }
  .nav-search-container #searchIcon svg {
    opacity: 0.45;
    width: 17px;
    height: 17px;
  }

  svg.icon {
    width: 17px;
    height: 17px;
  } */

.searchbar .category {
    text-transform: uppercase;
    color: rgb(154, 154, 172);
}

.searchbar a.search_result_more {
    display: inline-block;
    text-decoration: none;
    color: rgb(154, 154, 172);
    margin-right: 0;
    font-size: 90%;
    border-radius: 3px;
    background-color: transparent;
}

.searchbar a.search_result_more:hover {
    color: rgb(114, 114, 122);
}

.searchbar a.search_result {
    display: inline-block;
    text-decoration: none;
    color: rgb(32, 41, 50);
    margin-right: 11px;
    font-size: 90%;
    border-radius: 3px;
    background-color: rgba(0, 0, 0, 0.05);
    margin-bottom: 6px;
}

.searchbar a.search_result span {
    display: inline-block;
}

.searchbar a.search_result .label {
    padding-left: 7px;
    padding-right: 5px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    background-color: rgba(0, 0, 0, 0.05);
    color: rgba(32, 41, 50, 0.6);
}

.searchbar a.search_result .name {
    padding-left: 7px;
    padding-right: 5px;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
}

.searchbar a.search_result .count {
    padding-left: 7px;
    padding-right: 7px;
    border-top-right-radius: 3px;
    border-bottom-right-radius: 3px;
    background-color: rgba(0, 0, 0, 0.09);
    color: rgba(32, 41, 50, 0.6);
}
</style>
